import { render, staticRenderFns } from "./CurrentPlanCard.vue?vue&type=template&id=842a90b6"
import script from "./CurrentPlanCard.vue?vue&type=script&lang=js"
export * from "./CurrentPlanCard.vue?vue&type=script&lang=js"
import style0 from "./CurrentPlanCard.vue?vue&type=style&index=0&id=842a90b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports